export default function GetFullName(name: string | undefined, lastName: string | undefined): string {
  return [name?.trim(), lastName?.trim()].filter(Boolean).join(' ')
}
